export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.3.20-1741.26',
  commitId: '70213934ff9032d3626d7d35d32ff545217f7664',
  commitTime: '2026-03-20T17:41:26.000Z',
});
